import * as React from "react";
import InfoModal from "../../UI/InfoModal/InfoModal";
import DeviceContext from "../../Services/identifyDevice";
import "./DocStatusList.scss";
import AdhaarSample from "../../../assets/docSampleImages/Adhaar_Sample.png";
import DrivingLicense from "../../../assets/docSampleImages/DLSample.jpg";
import Passport from "../../../assets/docSampleImages/passportSample.jpg";
import VoterID from "../../../assets/docSampleImages/VoterID_Sample.jpg";
import SampleAadharPopup from "../SampleFolderPopups/SampleAadharPopup";
import SampleAadharMobileViewProps from "../SampleFolderPopups/SampleAadharPopupMobileView";
import SampleDrivingLicensePopup from "../SampleFolderPopups/SampleDrivingLicense";
import SampleSDLMobileViewProps from "../SampleFolderPopups/SampleDLMobile";
import SampleVoterIDPopup from "../SampleFolderPopups/SampleVoterIdPopup";
import SampleVoterIDMobileViewProps from "../SampleFolderPopups/SampleVoterIDMobile";
import SamplePassportPopup from "../SampleFolderPopups/SamplePassportPopup";
import SamplePassportMobileViewProps from "../SampleFolderPopups/SamplePassportMobile";

export interface DocStatusListProps {
  docName: string;
  //   docStatus: "Pending Upload" | "Pending Approval" | "Approved";
  docInfo: string;
}

const OptionDocumentList: React.FC<DocStatusListProps> = (props) => {
  const [showExplain, setShowExplain] = React.useState<boolean>(false);
  const [showAadhar, setShowAadhar] = React.useState<boolean>(false);
  const [showDL, setShowDL] = React.useState<boolean>(false);
  const [showDLMobile, setShowDLMobile] = React.useState<boolean>(false);
  const [showMobileAadhar, setShowMobileAadhar] =
    React.useState<boolean>(false);
  const [showVoterID, setShowVoterID] = React.useState<boolean>(false);
  const [showVoterIDMobile, setShowVoterIDMobile] =
    React.useState<boolean>(false);
  const [showPassport, setShowPassport] = React.useState<boolean>(false);
  const [showPassportMobile, setPassportMobile] =
    React.useState<boolean>(false);

  const setSamplePopups = (docType: string) => {
    switch (docType) {
      case "Adhaar":
        if (DeviceContext()?.isMobile) {
          setShowMobileAadhar(true);
        } else setShowAadhar(true);
        break;
      case "Driving License":
        if (DeviceContext()?.isMobile) {
          setShowDLMobile(true);
          // setShowMobileAadhar(true);
        } else setShowDL(true);
        break;
      case "Voter Id":
        if (DeviceContext()?.isMobile) {
          setShowVoterIDMobile(true);
          // setShowMobileAadhar(true);
        } else setShowVoterID(true);
        break;
      case "Passport":
        if (DeviceContext()?.isMobile) {
          setPassportMobile(true);
          // setShowMobileAadhar(true);
        } else setShowPassport(true);
        break;
    }
  };
  let InfomodalReturn = (doctype: string) => {
    switch (doctype) {
      case "Adhaar":
        return (
          <label>
            <img className="sampleImages" src={AdhaarSample} />
          </label>
        );
      case "Driving License":
        return (
          <label>
            <img className="sampleImages" src={DrivingLicense} />
          </label>
        );
      case "Voter Id":
        return (
          <label>
            <img className="sampleImages" src={VoterID} />
          </label>
        );
      case "Passport":
        return (
          <label>
            <img className="sampleImages" src={Passport} />
          </label>
        );
    }
  };

  return (
    <div className="docList">
      <label className="docName">{props.docName}</label>
      <div className="mgt40">
        <div
          className="fieldLblRight "
          onClick={() => {
            setSamplePopups(props?.docName);
          }}
          // onMouseOver={() => setShowExplain(true)}
          // onMouseLeave={() => setShowExplain(false)}
        >
          <div className="explain">
            <label className="explainLbl SampleImageText">Explain</label>
            {/* {showExplain && (
              <InfoModal width={DeviceContext().isMobile ? "328px" : "354px"}>
                <div className="explainInfo">
                  {InfomodalReturn(props.docName)}
                </div>
              </InfoModal>
            )} */}
          </div>
        </div>
        {showAadhar && (
          <SampleAadharPopup
            showPopup={showAadhar}
            setShowPopup={setShowAadhar}
          />
        )}
        {showMobileAadhar && (
          <SampleAadharMobileViewProps
            showPopup={showMobileAadhar}
            setShowPopup={setShowMobileAadhar}
          />
        )}
        {showDL && (
          <SampleDrivingLicensePopup
            showPopup={showDL}
            setShowPopup={setShowDL}
          />
        )}
        {showDLMobile && (
          <SampleSDLMobileViewProps
            showPopup={showDLMobile}
            setShowPopup={setShowDLMobile}
          />
        )}
        {showVoterID && (
          <SampleVoterIDPopup
            showPopup={showVoterID}
            setShowPopup={setShowVoterID}
          />
        )}
        {showVoterIDMobile && (
          <SampleVoterIDMobileViewProps
            showPopup={showVoterIDMobile}
            setShowPopup={setShowVoterIDMobile}
          />
        )}
        {showPassport && (
          <SamplePassportPopup
            showPopup={showPassport}
            setShowPopup={setShowPassport}
          />
        )}
        {showPassportMobile && (
          <SamplePassportMobileViewProps
            showPopup={showPassportMobile}
            setShowPopup={setPassportMobile}
          />
        )}
      </div>
    </div>
  );
};
export default OptionDocumentList;
